<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.手机号')" prop="mobile">
                <a-input v-model="queryParam.mobile"  @pressEnter="handleQuery" :placeholder="$t('通用.输入.请输入')+$t('用户.手机号')" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.邮箱')" prop="email">
                <a-input v-model="queryParam.email" @pressEnter="handleQuery" :placeholder="$t('通用.输入.请输入')+$t('用户.邮箱')" allow-clear/>
              </a-form-item>
            </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.昵称')" prop="nickName">
                <a-input v-model="queryParam.nickName" @pressEnter="handleQuery" :placeholder="$t('通用.输入.请输入')+$t('用户.昵称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.性别')" prop="sex">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户.性别')" v-model="queryParam.sex" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.SexEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.是否申请')" prop="appRole">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('店铺.是否申请')" style="width: 100%" v-model="queryParam.appRole" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.是否客服')" prop="loginRole">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户.是否客服')" style="width: 100%" v-model="queryParam.loginRole" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.用户状态')" prop="status">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户.用户状态')" style="width: 100%" v-model="queryParam.status" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.StatusEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.用户等级')" prop="status">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户.用户等级')" v-model="queryParam.levelId" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in levelList" :key="index" :value="d.id">{{ d.levelName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>-->
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['biz:user:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>
        <a-button type="primary" :disabled="multiple"  @click="handleSelectExport" v-hasPermi="['biz:user:export']">
          <a-icon type="download" />{{$t('通用.按钮.选中导出')}}
        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="sex" slot-scope="text, record">
            <!-- 重写自定义了个字典组件-->
           <custom-dict-tag :options="customDict.SexEnum" :value="record.sex"/>
        </span>
<!--        <span slot="isNotice" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_notice_status']" :value="record.isNotice"/>
        </span>-->
<!--        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status"/>
        </span>-->
        <span slot="status" slot-scope="text, record">
          <custom-dict-tag :options="customDict.StatusEnum" :value="record.status"/>
        </span>
        <template slot="avatar" slot-scope="text, record">
          <div>
            <img v-if="record.avatar" :src="record.avatar"  style="width:60px;height:62px;" v-image-preview alt="none"/>
          </div>
        </template>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="loginRole" slot-scope="text, record">
          <a-switch @change="(checked) => onRoleChange(checked,record)" :checked-children="$t('通用.文本.是')"
                    :un-checked-children="$t('通用.文本.否')" :checked="record.loginRole"/>
        </span>
        <span slot="isMerchant" slot-scope="text, record">
          <a-switch @change="(checked) => onMerchantChange(checked,record)" :checked-children="$t('通用.文本.是')"
                    :un-checked-children="$t('通用.文本.否')" :checked="record.isMerchant === 1"/>
        </span>
        <span slot="appRole" slot-scope="text, record">
           <custom-dict-tag :options="customDict.TFEnum" :value="record.appRole"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          
          <a @click="handleUpdate(record, undefined)">
               <a-icon type="edit"/>{{ $t('通用.按钮.修改') }}
          </a>
          <a v-if="record.isMerchant === 1" style="margin-left: 8px" @click="handleBindKf(record)">
            <a-icon type="team"/>{{ $t('用户.绑定客服') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        :pageSizeOptions="pageSizeOptions"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <!-- 绑定客服弹窗 -->
      <a-modal
        :visible="kfModalVisible"
        :title="$t('用户.绑定客服')"
        @cancel="kfModalVisible = false"
      >
        <a-spin :spinning="kfModalLoading">
          <a-descriptions :column="1" size="small">
            <a-descriptions-item :label="$t('用户.昵称')">
              {{ currentMerchant.nickName }}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('用户.手机号')">
              {{ currentMerchant.mobile }}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('用户.当前绑定客服')">
              <span v-if="currentKf">{{ currentKf.nickName }}（{{ currentKf.mobile }}）</span>
              <span v-else>{{ $t('用户.未绑定') }}</span>
            </a-descriptions-item>
          </a-descriptions>
          <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <a-form-item :label="$t('用户.选择客服')">
              <a-select v-model="selectedKfId" style="width: 100%" show-search
                        :filter-option="filterKfOption"
                        :placeholder="$t('通用.输入.请输入')+$t('用户.客服')">
                <a-select-option v-for="kf in kfOptionsList" :key="kf.id" :value="kf.id">
                  {{ kf.nickName }}（{{ kf.mobile }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-form>
        </a-spin>
        <template slot="footer">
          <a-button @click="kfModalVisible = false">{{ $t('通用.按钮.取消') }}</a-button>
          <a-button v-if="currentKf" type="danger" :loading="kfSubmitting" @click="handleUnbindKf">
            {{ $t('用户.取消绑定') }}
          </a-button>
          <a-button type="primary" :loading="kfSubmitting" @click="handleBindKfConfirm">
            {{ $t('用户.绑定换绑') }}
          </a-button>
        </template>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUser,listUser, delUser,updateRole, updateMerchant } from '@/api/biz/user'
import { kfOptions, merchantKfPage, bindMerchantKf, unbindMerchantKf } from '@/api/biz/userMerchantKf'
import CreateForm from './modules/CreateForm'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import { tableMixin } from '@/store/table-mixin'
import {listLevel} from "@/api/user/level";
import events from "@/components/MultiTab/events";
import bus from "@/utils/bus";
import {updateShopRecommend} from "@/api/shop/shop";

export default {
  name: 'User',
  components: {
    CreateForm,
    CustomDictTag
  },
  mixins: [tableMixin],
  data () {
    return {
      pageSizeOptions: ['10', '20', '50', '100'],
      list: [],
      levelList: [],

      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 绑定客服弹窗
      kfModalVisible: false,
      kfModalLoading: false,
      kfSubmitting: false,
      kfOptionsList: [],
      currentMerchant: {},
      currentKf: null,
      selectedKfId: undefined,
      // 查询参数
      queryParam: {
        mobile: null,
        email: null,
        nickName: null,
        sex: undefined,
        loginRole:undefined,
        appRole:undefined,
        invitationCode: null,
        isNotice: null,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('用户.手机号'),
          dataIndex: 'mobile',
          align: 'center'
        },
        /*{
          title: this.$t('用户.邮箱'),
          dataIndex: 'email',
          align: 'center'
        },*/
        {
          title: this.$t('用户.昵称'),
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户.头像'),
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatar' },
          align: 'center'
        },
        /*{
          title: this.$t('用户.真实姓名'),
          dataIndex: 'realName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户.微信'),
          dataIndex: 'weChat',
          ellipsis: true,
          align: 'center'
        },
        {
          title: "qq",
          dataIndex: 'qq',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户.用户等级'),
          dataIndex: 'levelName',
          align: 'center'
        },*/
        {
          title: this.$t('用户.性别'),
          dataIndex: 'sex',
          scopedSlots: { customRender: 'sex' },
          align: 'center'
        },
        {
          title: this.$t('用户.是否客服'),
          dataIndex: 'loginRole',
          scopedSlots: { customRender: 'loginRole' },
          align: 'center'
        },
        {
          title: this.$t('用户.是否商户'),
          dataIndex: 'isMerchant',
          scopedSlots: { customRender: 'isMerchant' },
          align: 'center'
        },
       /* {
          title: this.$t('用户.是否申请'),
          dataIndex: 'appRole',
          scopedSlots: { customRender: 'appRole' },
          align: 'center'
        },*/
        /*{
          title:  this.$t('用户.生日'),
          dataIndex: 'birthday',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('用户.用户状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户.注册时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getLevelList();
    this.getList()
    /**编辑页面接收到更新的数据 */
    bus.$on('updateShopList',()=>{
      this.getList()
    })
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    /** 查询用户信息列表 */
    getList () {
      this.loading = true
     pageUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    onRoleChange(checked, record) {
      //  当前客服是默认客服的情况下
      if(checked==false && record.service){
        this.$message.error('当前客服为默认客服,请先转移默认客服在进行取消！');
        return false;
      }
      let data = {id: record.id, shopRecommend: checked}
      updateRole(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('通用.文本.修改成功'),
            3
          );
          this.$emit('ok')
          record.loginRole = checked
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    onMerchantChange(checked, record) {
      let data = {id: record.id, shopRecommend: checked}
      updateMerchant(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('通用.文本.修改成功'),
            3
          );
          this.$emit('ok')
          record.isMerchant = checked ? 1 : 0
        }
      }).catch(() => {
        this.$message.error(this.$t('通用.文本.修改失败'))
      }).finally(() => {
        this.submitLoading = false
      })
    },
    /** 客服下拉筛选(昵称/手机号) */
    filterKfOption(input, option) {
      const kf = this.kfOptionsList.find(item => String(item.id) === String(option.componentOptions.propsData.value))
      if (!kf) return false
      const keyword = String(input || '').trim().toLowerCase()
      return (kf.nickName || '').toLowerCase().indexOf(keyword) >= 0
        || (kf.mobile || '').toLowerCase().indexOf(keyword) >= 0
    },
    /** 打开绑定客服弹窗 */
    handleBindKf(record) {
      this.currentMerchant = record
      this.currentKf = null
      this.selectedKfId = undefined
      this.kfModalVisible = true
      this.kfModalLoading = true
      // 查询可选客服列表
      kfOptions().then(response => {
        this.kfOptionsList = response.data || []
      }).finally(() => {
        this.kfModalLoading = false
      })
      // 查询当前商家绑定客服信息
      merchantKfPage({ mobile: record.mobile, pageNum: 1, pageSize: 1 }).then(response => {
        const data = response.data && response.data.records ? response.data.records[0] : null
        if (data && data.bound) {
          this.currentKf = { id: data.kfId, nickName: data.kfNickName, mobile: data.kfMobile }
          this.selectedKfId = data.kfId
        }
      })
    },
    /** 绑定/换绑客服 */
    handleBindKfConfirm() {
      if (!this.selectedKfId) {
        this.$message.warning(this.$t('用户.请选择客服'))
        return
      }
      if (this.currentKf && this.selectedKfId === this.currentKf.id) {
        this.$message.warning(this.$t('用户.当前客服已绑定'))
        return
      }
      this.kfSubmitting = true
      bindMerchantKf({ merchantId: this.currentMerchant.id, kfId: this.selectedKfId }).then(() => {
        this.$message.success(this.$t('通用.文本.修改成功'))
        this.kfModalVisible = false
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('通用.文本.修改失败'))
      }).finally(() => {
        this.kfSubmitting = false
      })
    },
    /** 取消绑定客服 */
    handleUnbindKf() {
      const that = this
      this.$confirm({
        title: this.$t('用户.取消绑定'),
        content: this.$t('用户.确认取消绑定'),
        okType: 'danger',
        onOk () {
          that.kfSubmitting = true
          return unbindMerchantKf({ merchantId: that.currentMerchant.id }).then(() => {
            that.$message.success(that.$t('通用.文本.修改成功'))
            that.kfModalVisible = false
            that.getList()
          }).catch(() => {
            that.$message.error(that.$t('通用.文本.修改失败'))
          }).finally(() => {
            that.kfSubmitting = false
          })
        }
      })
    },
    getLevelList () {
      listLevel().then(response => {
        this.levelList = response.data
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    /** 编辑商品信息 **/
    handleUpdate(row) {debugger
      this.$router.push({
        path: 'userdetail',
        query:
          {
            id: row.id
          }
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        mobile: undefined,
        email: undefined,
        nickName: undefined,
        sex: undefined,
        loginRole:undefined,
        appRole:undefined,
        invitationCode: undefined,
        isNotice: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('biz/user/export', {
            ...that.queryParam
          }, `用户信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleSelectExport () {
      var that = this
      let queryParam = {"idList": this.ids}
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出选中数据'),
        onOk () {
          that.download('biz/user/export', queryParam, `用户信息_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        },
        onCancel () {
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        }
      })
    }
  }
}
</script>
